module.exports = __webpack_public_path__ + "media/images/ui__arrowRight-fc56cc68e963f397bdf3d4dbe4908f7c.png";